import {
  LOAD_REDIRECTS,
  LOAD_REDIRECTS_FAIL,
  LOAD_REDIRECTS_SUCCESS,
  LoadRedirectsSuccess
} from '../actions/hosting-redirects.action';
import {RedirectAction} from "../actions";
import {HostingRedirectData} from "../../websites/website/hosting/redirects/hostingRedirectData";

export interface IHostingEntityState {
  entities: {[websiteId: number]: HostingRedirectData};
  loading: boolean;
  loaded: boolean;
}

export interface IHostingRedirectsState {
  entities: {[websiteId: number]: IHostingEntityState};
}

export const initialState: IHostingRedirectsState = {
  entities: {}
};

export function reducer(state: IHostingRedirectsState = initialState, action: RedirectAction): IHostingRedirectsState {
  let payload: any;

  switch (action.type) {

    case LOAD_REDIRECTS:
      payload = (<LoadRedirectsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_REDIRECTS_SUCCESS:
      payload = (<LoadRedirectsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case LOAD_REDIRECTS_FAIL:
      payload = (<LoadRedirectsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

  }

  return state;
}
